import React from "react";

const TechBackground = ({ color = "#1e90ff" }) => {
  return (
    <div style={styles.wrapper}>
      <svg
        viewBox="0 0 1200 600"
        preserveAspectRatio="xMidYMid slice"
        style={{ width: "100%", height: "100%" }}
      >
        <defs>
          <style>
            {`
              .glow-line {
                fill: none;
                stroke: ${color};
                stroke-width: 2;
                filter: drop-shadow(0 0 6px ${color});
                stroke-dasharray: 200;
                stroke-dashoffset: 200;
                animation: draw-line 1.6s linear infinite;
              }

              .glow-line.delay {
                animation-delay: 0.6s;
              }

              .polygon {
                fill: none;
                stroke: ${color};
                stroke-width: 1.5;
                opacity: 0.5;
                filter: drop-shadow(0 0 8px ${color});
                animation: pulse 1.5s ease-in-out infinite;
              }

              @keyframes draw-line {
                to {
                  stroke-dashoffset: -200;
                }
              }

              @keyframes pulse {
                0%, 100% { opacity: 0.35; }
                50% { opacity: 1; }
              }
            `}
          </style>
        </defs>

        {/* Circuit Lines */}
        <path className="glow-line" d="M0 120 H300 L350 160 H600" />
        <path className="glow-line delay" d="M200 260 H500 L560 220 H900" />
        <path className="glow-line" d="M100 420 H400 L460 380 H800" />

        {/* Vertical Links */}
        <path className="glow-line delay" d="M350 160 V260" />
        <path className="glow-line" d="M560 220 V380" />

        {/* Polygons */}
        <polygon className="polygon" points="900,100 960,140 920,200 860,160" />
        <polygon className="polygon" points="150,300 220,340 190,410 120,370" />
        <polygon className="polygon" points="700,420 760,460 720,520 660,480" />
      </svg>
    </div>
  );
};

const styles = {
  wrapper: {
    position: "fixed",
    inset: 0,
    zIndex: -1, // 🔥 stays behind content
    backgroundColor: "#05070d",
    overflow: "hidden",
  },
};

export default TechBackground;
